module.exports = __webpack_public_path__ + "static/media/Background.66360ebd.png";